export function module_common() {
	
	$(function() {
		var ua = navigator.userAgent;
		
		$('#panel-btn').on('click',function(){
			responsiveToggle();
		});
		$('#header .responsive a').on('click',function(){
			responsiveToggle();
		});
		$('#header a.page-top').on('click',function(){
			if($('#panel-btn-icon').is('.close')){
				responsiveToggle();
			}
			//var speed = 300;
			//$('html, body').animate({scrollTop: 0}, speed, 'swing');
			//return false;
		});

		function responsiveToggle(){
			$('#panel-btn-icon').toggleClass('close');

			if(ua.match(/android/i)){
				$('#header .responsive').fadeToggle(200);
			} else {
				$('#header .responsive').slideToggle(200);
			}
		}

		// sp menu open
		$(document).ready(function () {
			spMenuOpen();
			gNavSub();

			$(window).on('resize orientationchange', function() {
				spMenuOpen();
				gNavSub();
			});

			// sp menu open
			function spMenuOpen() {
				var winH = $(window).height();
				var headerH = $('.spHeader').height();
				if(!$('#header .navbar').is(':visible')){
					//console.log('sp');
					//responsive nav white over ray
					$('#header .responsive').css({'height':winH, 'top':headerH});
				}
			}

			// sp document menu open
			function gNavSub() {
				var sideMenuList = $('.navChildren');
				var sideToggleBtn = $('.btnSpDocument');

				if($(window).width() < 640) {
					$(sideMenuList).hide();
					$(sideToggleBtn).unbind('click');

					$(sideToggleBtn).on("click", function(event){
						event.preventDefault();
						$(this).next().slideToggle();
						$(this).toggleClass('btnSpDocumentOpen');
					});
				} else {
					$(sideMenuList).show();
					$(sideToggleBtn).unbind('click');
				}

				if(!$(sideMenuList).is(':visible')){
					$(sideToggleBtn).removeClass('btnSpDocumentOpen');
				}
			}
		});


		// header search focus color
		$(".siteSearch input").focus(function(){
			$(".osd .siteSearch i").css("color", "#01579b");
		}).blur(function(){
			$(".osd .siteSearch i").css("color", "#FFF");
		});
	});


	$(window).on('load', function() {
		var winH = $(window).height();
		
		var url = $(location).attr('href');
		if(!$('#header .navbar').is(':visible')){
			//console.log('sp');
			var headH = 72;
		} else {
			//console.log('pc');
			var headH = 150;
		}
		if(url.indexOf('?id=') != -1){
			var id = url.split('?id=');
			var $target = $('#' + id[id.length - 1]);
			if($target.length){
				var pos = $target.offset().top-headH;
				$('html, body').animate({scrollTop:pos}, 300, 'swing');
			}
		}
	});
	
	$(function() {
		commonContents();

		var timer = false;
		var count = 0;
		var winWidth = $(window).width();
		var winHeight = $(window).height();
		var winWidth_resized;
		var winHeight_resized;

		//--------------------------------------------------------
		// Resize Event
		//--------------------------------------------------------
		$(window).on('resize', function() {
			// リサイズ後の放置時間が指定ミリ秒以下なら何もしない(リサイズ中に何度も処理が行われるのを防ぐ)
			if (timer !== false) {
				clearTimeout(timer);
			}

			// 放置時間が指定ミリ秒以上なので処理を実行
			timer = setTimeout(function() {
				// リサイズ後のウインドウの横幅・高さを取得
				winWidth_resized = $(window).width();
				winHeight_resized = $(window).height();

				// リサイズ前のウインドウ幅・髙さとリサイズ後のウインドウ幅・髙さが異なる場合
				if ( winWidth != winWidth_resized || winHeight != winHeight_resized ) {
					commonContents();

					// 次回以降使えるようにリサイズ後の幅・髙さをウインドウ幅に設定する
					winWidth = $(window).width();
					winHeight = $(window).height();
				}
			}, 200);
		});

		//リサイズ用関数
		function commonContents() {
			//timerをクリア、countをリセット
			clearTimeout(timer);
			count = 0;

			//画面高さを取得
			var wHeight = $(window).height();
			//ヘッダー高さを取得
			var headerHeight = $('#header').height();
			//ヘッダーロゴの src取得
			var logoSrc = $('.h-logo-pc').children('img').attr('src');
			
			function logoBlue() {
				var src = logoSrc.replace('logo-pc-white.svg', 'logo-pc.svg');
				$('.h-logo-pc').children('img').attr('src', src);
			}
			function logoWhite() {
				var src = logoSrc.replace('logo-pc.svg', 'logo-pc-white.svg');
				$('.h-logo-pc').children('img').attr('src', src);
			}
			
			if(window.innerWidth >= 1100) {
				logoWhite();
				if($('#header').hasClass('headerfix')) {
					logoBlue();
				}
			} else {
				logoBlue();
				$(window).on('load scroll', function () {
					logoBlue();
				});
			}
			
			//Pagetop & Header Class
			var topBtn = $('.pagetop');	
			topBtn.hide();

			$(window).on('scroll', function () {
				if ($(this).scrollTop() > 160) {
					topBtn.fadeIn();
				} else {
					topBtn.fadeOut();
				}

				if ($(this).scrollTop() > 260) {
					$('#header, .spHeader').addClass('headerfix');
					logoBlue();
				} else {
					$('#header, .spHeader').removeClass('headerfix');
					if(window.innerWidth >= 1024) {
						logoWhite();
					} else {
						logoBlue();
					}
				}
			});

			//スクロールしてトップ
			topBtn.click(function () {
				$('body,html').animate({
					scrollTop: 0
				}, 800,'swing');
				return false;
			});
		}
	});
	

	//--------------------------------------------------------
	// Magnific Popup Setteing
	//--------------------------------------------------------
	//拡張子の配列
	var arrayExtensions = ['.jpg', '.jpeg', '.gif', '.png'];
	//クラス名を入れる配列
	var extensionsLength = [];
	//クラス名＋拡張子をループ
	$.each( arrayExtensions, function() {
		var magnificClass = '#main a[href$="' + this + '"]';
		//クラス名を配列に入れる
		extensionsLength.push(magnificClass);
	});
	//カンマ区切りでクラス名の文字列を出力
	var extensions = extensionsLength.join();

	$(extensions).each(function() {
		$(this).magnificPopup({
			type: 'image',
			mainClass: 'mfp-fade',
			removalDelay: 500,
			preloader: false,
			gallery:{enabled:true}
		});
	});


	//--------------------------------------------------------
	// Smooth Scroll
	//--------------------------------------------------------
	$(window).on('load',function() {
		var offset = 80;
		var speed = 500;
		var arr = [
			'#header .navbar ul li a',
			'.reference-list li a',
			'.guide-block-group li a',
			'.btn-hash',
			'#toc_container a[href*="#"]'
		];
		var str = arr.join(',');

		$(str).on('click', function () {
			var target = $(this.hash);

			if (target) {
				var targetOffset = target.offset().top;
				$('html, body').animate({scrollTop: targetOffset - offset}, speed, 'swing');
				return false;
			}
		});
	});

	//外部からのリンク
	$(window).on('load',function() {
		pageScrolling();
	});

	function pageScrolling() {
		var offset = 80;

		var ua = navigator.userAgent.toLowerCase();

		if (location.href.indexOf('#') != -1) {
			var target = $('#' + location.href.split('#')[1]);
			if ($(target).length) {
				var position = target.offset().top - offset;
			}

			$('body, html').animate({scrollTop: position}, 1, 'swing');
		}

		if (/iphone/.test(ua) || /ipad/.test(ua) || /safari/.test(ua)) {
			$('a[href*="#"]').not('.external-link').each(function() {
				var orgHref = $(this).attr('href');
				var index = orgHref.lastIndexOf('#');

				if (index != 0) {
					var hash = orgHref.substr(index).substr(1);
					var href = orgHref.substr(0,index);

					if (href.match(/\?/)) {
						var connector = '&';
					} else {
						connector = '?';
					}

					$(this).attr('href', href + connector + 'js-hash=' + hash);
				}
			});

			if (getQueryVariable('js-hash')) {
				var name = getQueryVariable('js-hash');
				var target = $('#' + name);
				var offsetTop = target.offset().top - offset;

				$('html, body').animate({scrollTop: offsetTop}, 1);
			}
		}
	}

	function getQueryVariable(variable) {
		var query = window.location.search.substring(1);
		var vars = query.split('&');

		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split('=');

			if (pair[0] == variable) {
				return pair[1];
			}
		}

		return false;
	}
}